import { lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router';
import { CanRoute } from '@arc/frontend/util-auth';
import { Root } from './app/_Root';
import App from './app/App';
import LoginPage from './app/Login/LoginPage';
import { ResetPassword } from './app/Login/ResetPassword';
import { WelcomeView } from './app/Login/WelcomeView';
const ArcRolesPage = lazy(() => import('./app/ArcRoles/ArcRolesPage'));
const ArcRoleViewPage = lazy(() => import('./app/ArcRoles/ArcRoleView/ArcRoleView'));
const AuditLogsPage = lazy(() => import('./app/AuditLogs/AuditLogsPage'));
const BuildsListPage = lazy(() => import('./app/Builds/BuildsListPage'));
const BuildViewPage = lazy(() => import('./app/Builds/BuildView'));
const CleanupPage = lazy(() => import('./app/Cleanup/CleanupPage'));
const DeployGroupsPage = lazy(() => import('./app/DeployGroups/DeployGroupsPage'));
const DeploymentsListPage = lazy(() => import('./app/Deployments/DeploymentsListPage'));
const DeploymentViewPage = lazy(() => import('./app/Deployments/DeploymentView'));
const DeployPipelinesPage = lazy(() => import('./app/DeployPipelines/DeployPipelinesPage'));
const JobsListPage = lazy(() => import('./app/Jobs/JobListPage'));
const MemberLogInToArcPage = lazy(() => import('./app/Members/MemberLogInToArcPage'));
const MemberTagsPage = lazy(() => import('./app/MemberTags/MemberTagsPage'));
const MembersListPage = lazy(() => import('./app/Members/MembersList'));
const MemberViewPage = lazy(() => import('./app/Members/MemberView'));
const NoRoleSelectedPage = lazy(() => import('./app/Roles/NoRoleSelectedPage'));
const OnCallSchedulePage = lazy(() => import('./app/OnCallSchedule'));
const ReleasesPage = lazy(() => import('@arc/frontend/util-releases'));
const RoleFormAddPage = lazy(() => import('./app/Roles/RoleForm/RoleFormAddPage'));
const RoleFormEditPage = lazy(() => import('./app/Roles/RoleForm/RoleFormEditPage'));
const RolesPage = lazy(() => import('./app/Roles/RolesPage'));
const UsersListPage = lazy(() => import('./app/Users/UsersList'));
const UserViewPage = lazy(() => import('./app/Users/UserView'));
export const router = createBrowserRouter(createRoutesFromElements(<Route element={<Root />}>
			<Route path="login" element={<LoginPage />} />
			<Route path="reset-password/:token" element={<ResetPassword />} />
			<Route path="welcome/:token" element={<WelcomeView />} />
			<Route path="*" element={<App />}>
				<Route path="" element={<Navigate to="/members" replace />} />
				<Route path="jobs" element={<CanRoute I="list" a="Job" Component={JobsListPage} />} />
				<Route path="builds">
					<Route path="" element={<CanRoute I="list" a="Build" Component={BuildsListPage} />} />
					<Route path=":buildId" element={<CanRoute I="view" a="Build" Component={BuildViewPage} />} />
				</Route>
				<Route path="cleanup" element={<CanRoute I="list" a="Job" Component={CleanupPage} />} />
				<Route path="deploy-groups" element={<CanRoute I="list" a="Deployment/Group" Component={DeployGroupsPage} />} />
				<Route path="deploy-pipelines" element={<CanRoute I="list" a="Deployment/Pipeline" Component={DeployPipelinesPage} />} />
				<Route path="deployments">
					<Route path="" element={<CanRoute I="list" a="Deployment" Component={DeploymentsListPage} />} />
					<Route path=":deploymentId" element={<CanRoute I="view" a="Deployment" Component={DeploymentViewPage} />} />
				</Route>
				<Route path="members">
					<Route path="" element={<CanRoute I="list" a="Member" Component={MembersListPage} />} />
					<Route path=":avbId" element={<CanRoute I="view" a="Member" Component={MemberViewPage} />} />
					<Route path=":avbId/login" element={<CanRoute I="view" a="Member" Component={MemberLogInToArcPage} />} />
				</Route>
				<Route path="tags" element={<CanRoute I="list" a="Member" Component={MemberTagsPage} />} />
				<Route path="users">
					<Route path="" element={<CanRoute I="list" a="User" Component={UsersListPage} />} />
					<Route path=":userId" element={<CanRoute I="view" a="User" Component={UserViewPage} />} />
				</Route>
				<Route path="roles" element={<CanRoute I="list" a="Role" Component={RolesPage} />}>
					<Route path="" element={<NoRoleSelectedPage />} />
					<Route path="add" element={<RoleFormAddPage />} />
					<Route path="*" element={<RoleFormEditPage />} />
				</Route>
				<Route path="audit-logs" element={<AuditLogsPage />} />
				<Route path="oncall-schedule" element={<OnCallSchedulePage />} />
				<Route path="arc-roles">
					<Route path="" element={<CanRoute I="list" a="ArcRole" Component={ArcRolesPage} />} />
					<Route path=":arcRoleId" element={<CanRoute I="view" a="ArcRole" Component={ArcRoleViewPage} />} />
				</Route>
				<Route path="releases/*" element={<ReleasesPage />} />
			</Route>
		</Route>));